import PropTypes from 'prop-types';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useIntl } from '@zenbusiness/application-commons-intl';
import IconButton from '@zenbusiness/zui/IconButton';

import * as Styled from './SubscriptionMenu.style';
import { ThreeDotMenu } from './ThreeDotMenu';

export function SubscriptionMenu({
  subscription,
  billingChangeSavings,
  domesticJurisdiction,
  hasSubProducts,
  checked,
  setChecked,
  isIncluded = false,
  businessEntityUuid,
}) {
  const { formatMessage } = useIntl();
  const { payment = [], canChangePeriod } = subscription;
  const paymentStatus = payment[0]?.paymentStatus || '';

  return (
    <Styled.MenuStack alignItems="center" justifyContent="center">
      <ThreeDotMenu
        subscription={subscription}
        paymentStatus={paymentStatus}
        canChangePeriod={canChangePeriod || false}
        billingChangeSavings={billingChangeSavings}
        domesticJurisdiction={domesticJurisdiction}
        isIncluded={isIncluded}
        businessEntityUuid={businessEntityUuid}
      />
      {hasSubProducts && (
        <IconButton
          aria-label="details-dropdown"
          label={formatMessage({ id: 'dashboard.subscriptions.menu.toggleDetails' })}
          clickstreamProps={{ elementName: 'subscription_toggle_details' }}
          icon={
            <ExpandMoreIcon
              sx={{
                color: 'primary.main',
                fontSize: '2rem',
                transform: checked ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: (theme) =>
                  theme.transitions.create('all', {
                    duration: '300ms',
                  }),
              }}
            />
          }
          onClick={(e) => {
            setChecked(!checked);
            e.currentTarget.blur();
          }}
        />
      )}
    </Styled.MenuStack>
  );
}

SubscriptionMenu.propTypes = {
  subscription: PropTypes.shape({
    payment: PropTypes.arrayOf(PropTypes.shape({ paymentStatus: PropTypes.string })),
    canChangePeriod: PropTypes.bool,
    service: PropTypes.string,
  }).isRequired,
  billingChangeSavings: PropTypes.number,
  domesticJurisdiction: PropTypes.string,
  hasSubProducts: PropTypes.bool,
  checked: PropTypes.bool,
  setChecked: PropTypes.func,
  isIncluded: PropTypes.bool,
  businessEntityUuid: PropTypes.string,
};
